import Modal from "@/components/Modal/Modal";
import FormControl from "@/components/FormControl/FormControl";
import { useEffect, useState,memo } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch } from "@/store/store";
import DeleteIcon from "@mui/icons-material/Delete";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ViewLocation from "@/components/ViewLocation/ViewLocation";
interface IManageGeofence {
    modalOpen: boolean;
    closeModal: () => void;
    saveModal: (payload: any) => void;
    selectedUser: any;
}

// Minimalist pill markup with a removal click handler
const SelectedListItem = ({ item, onRemove, handleOnClickLocation }: { item: any; onRemove: () => void; handleOnClickLocation: (item: any) => void }) => (
    <div className="flex items-center justify-between w-full bg-neutral-50 hover:bg-neutral-100 border border-solid border-neutral-200 rounded-md p-2.5 transition-colors group">
        <div className="flex items-start gap-2 cursor-pointer"
            onClick={() => handleOnClickLocation(item)}
        >
            {/* Small decorative map marker dot */}
            <button
                type="button"
                className="w-6 h-6 rounded-md flex items-center justify-center  text-neutral-400 hover:text-blue-700 font-bold border-none cursor-pointer transition-all text-base"
                title="View location"
            >
                <LocationOnOutlinedIcon />
            </button>
            <div className="text-sm font-medium text-neutral-700">{item.Name} {item.GeoFenceTypeName && `(${item.GeoFenceTypeName})`}</div>
            {(item.Latitude || item.Longitude) && (
                <div className="text-xs text-neutral-500 font-medium tracking-wide mt-0.5">
                    {formatCoordinates(item.Latitude, item.Longitude, item.Range)}
                </div>
            )}
        </div>
        <button
            type="button"
            onClick={onRemove}
            className="w-6 h-6 rounded-md flex items-center justify-center hover:bg-red-50 text-neutral-400 hover:text-red-600 font-bold border-none cursor-pointer transition-all text-base"
            title="Remove location"
        >
            <DeleteIcon />
        </button>
    </div>
);


const formatCoordinates = (lat: number, lng: number, range: number) => {
    if (!lat || !lng) return;

    const latDir = lat >= 0 ? "° N" : "° S";
    const lngDir = lng >= 0 ? "° E" : "° W";

    return `${Math.abs(lat).toFixed(4)}${latDir}, ${Math.abs(lng).toFixed(4)}${lngDir} · Radius ${range || 0} m`;
}

const ManageGeofence = ({ modalOpen, closeModal, saveModal, selectedUser }: IManageGeofence) => {

    const [location, setLocation] = useState({ lat: "", lng: "" });
    const [modalOpenViewLocation, setModalOpenViewLocation] = useState(false);
    const [punchInGeofences, setPunchInGeofences] = useState<any[]>([]);
    const [punchOutGeofences, setPunchOutGeofences] = useState<any[]>([]);


    const [originalPunchIn, setOriginalPunchIn] = useState<any[]>([]);
    const [originalPunchOut, setOriginalPunchOut] = useState<any[]>([]);

    const { control, setValue, watch } = useForm();
    const label = `Manage Geofences - ${selectedUser?.UserName || ""}`;

    const dispatch = useDispatch<AppDispatch>();

    // Fetch the geofence options from the team slice
    const { geoFencingArea } = useSelector((state: any) => state.team);
    const { loading } = useSelector((state: any) => state.usergeofenceManagement);

    // Watch form drop-downs for new selections
    const watchedPunchIn = watch("punchInSelect");
    const watchedPunchOut = watch("punchOutSelect");


    const availablePunchInOptions = geoFencingArea?.filter(
        (option: any) =>
            !punchInGeofences.some(
                (selected) => selected.Id === option.Id
            )
    );

    const availablePunchOutOptions = geoFencingArea?.filter(
        (option: any) =>
            !punchOutGeofences.some(
                (selected) => selected.Id === option.Id
            )
    );

    // in   
    const punchInOptions = availablePunchInOptions.map((item: any) => (
        {
            ...item,
            DisplayName: item.GeoFenceTypeName ? `${item.Name} (${item.GeoFenceTypeName})` : item.Name,
        }

    ))

    //out 
    const punchOutOptions = availablePunchOutOptions?.map((item: any) => ({
        ...item,
        DisplayName: item.GeoFenceTypeName ? `${item.Name} (${item.GeoFenceTypeName})` : item.Name,
    }))
    //view location 
    const handleOnClickLocation = (item: any) => {

        setLocation({ lat: item.Latitude, lng: item.Longitude });
        setModalOpenViewLocation(true);
    }


    const buildGeoFencePayload = (userId: number, punchInList: any[], punchOutList: any[]) => {
        const count = Math.max(punchInList.length, punchOutList.length);

        const geoFences = [];

        for (let i = 0; i < count; i++) {

            const inItem = punchInList[i];
            const outItem = punchOutList[i];

            geoFences.push({
                PunchInGeoFenceId: inItem?.Id ?? null,
                PunchOutGeoFenceId: outItem?.Id ?? null,
            });
        }

        return {
            UserIds: [userId],
            GeoFences: geoFences
        };
    };

    const enrichGeofences = (geofences: any[]) =>
        (geofences || []).map((item: any) =>
            geoFencingArea?.find((area: any) => area.Id === item.Id) || item
        );

    // 5. Clear item handlers
    const removePunchIn = (id: any) => {
        setPunchInGeofences((prev) => prev.filter((item) => item.Id !== id));
    };

    const removePunchOut = (id: any) => {
        setPunchOutGeofences((prev) => prev.filter((item) => item.Id !== id));
    };


    const handleSubmitGeofence = async () => {

        const userId = Number(selectedUser?.UserId);

        const addedPunchIn = punchInGeofences.filter(x => !originalPunchIn.some(y => y.Id === x.Id));

        const removedPunchIn = originalPunchIn.filter(x => !punchInGeofences.some(y => y.Id === x.Id));

        const addedPunchOut = punchOutGeofences.filter(x => !originalPunchOut.some(y => y.Id === x.Id));

        const removedPunchOut = originalPunchOut.filter(x => !punchOutGeofences.some(y => y.Id === x.Id));

        const addPayload = buildGeoFencePayload(userId,addedPunchIn,addedPunchOut);

        const removePayload = buildGeoFencePayload(userId,removedPunchIn,removedPunchOut);

        saveModal({
            addPayload,
            removePayload
        });
    };

    useEffect(() => {
        if (modalOpen && selectedUser) {

            const punchIn = enrichGeofences(selectedUser?.PunchInGeoFences || []);
            const punchOut = enrichGeofences(selectedUser?.PunchOutGeoFences || []);

            setPunchInGeofences(punchIn);
            setPunchOutGeofences(punchOut);

            setOriginalPunchIn(punchIn);
            setOriginalPunchOut(punchOut);
        }
    }, [modalOpen, selectedUser, geoFencingArea]);


    // 3. Handle adding a new selection to the Punch In list
    useEffect(() => {
        if (watchedPunchIn) {
            const selectedItem = geoFencingArea?.find((g: any) => g.Id === watchedPunchIn);

            if (selectedItem && !punchInGeofences.some((g) => g.Id === selectedItem.Id)) {
                setPunchInGeofences((prev) => [...prev, selectedItem]);
            }

            setValue("punchInSelect", ""); // Reset drop-down back to placeholder
        }
    }, [watchedPunchIn, geoFencingArea, punchInGeofences, setValue]);

    // 4. Handle adding a new selection to the Punch Out list
    useEffect(() => {
        if (watchedPunchOut) {
            const selectedItem = geoFencingArea?.find((g: any) => g.Id === watchedPunchOut);

            if (selectedItem && !punchOutGeofences.some((g) => g.Id === selectedItem.Id)) {
                setPunchOutGeofences((prev) => [...prev, selectedItem]);
            }

            setValue("punchOutSelect", ""); // Reset drop-down back to placeholder
        }
    }, [watchedPunchOut, geoFencingArea, punchOutGeofences, setValue]);
    return (
        <Modal
            modalOpen={modalOpen}
            closeModal={closeModal}
            heading={label}
            onSave={handleSubmitGeofence}
            saveButtonText="Save"
            width="450px"
            isLoading={loading?.userGeofences}
        >
            <div className="flex flex-col gap-6 pt-2">

                {/* --- PUNCH IN CONTROL WRAPPER --- */}
                <div >
                    <FormControl
                        name="punchInSelect"
                        label="Add Punch In Geofence"
                        controlType="select"
                        control={control}
                        options={punchInOptions || []}
                        idKey="Id"
                        nameKey="DisplayName"
                    />
                    <div className="flex flex-wrap gap-1 mt-2 min-h-6 ">
                        {punchInGeofences.length === 0 ? (

                            <div>No geofence added</div>
                        ) : (
                            punchInGeofences.map((item) => (
                                <SelectedListItem
                                    key={item.Id}
                                    item={item}
                                    onRemove={() => removePunchIn(item.Id)}
                                    handleOnClickLocation={handleOnClickLocation}
                                />
                            )
                            ))
                        }
                    </div>
                </div>

                {/* --- PUNCH OUT CONTROL WRAPPER --- */}
                <div>
                    <FormControl
                        name="punchOutSelect"
                        label="Add Punch Out Geofence"
                        controlType="select"
                        control={control}
                        options={punchOutOptions || []}
                        idKey="Id"
                        nameKey="DisplayName"
                    />
                    <div className="flex flex-wrap gap-1 mt-2 min-h-6">
                        {punchOutGeofences.length === 0 ? (
                            <div>No geofence added</div>
                        ) : (
                            punchOutGeofences.map((item) => (
                                <SelectedListItem
                                    key={item.Id}
                                    item={item}
                                    onRemove={() => removePunchOut(item.Id)}
                                    handleOnClickLocation={handleOnClickLocation}
                                />
                            ))
                        )}
                    </div>
                </div>

            </div>

            {modalOpenViewLocation && (
                <ViewLocation
                    title="Location"
                    width="800px"
                    modalOpen={modalOpenViewLocation}
                    closeModal={() => setModalOpenViewLocation(false)}
                    lat={location.lat}
                    lng={location.lng}
                />
            )}
        </Modal>
    );
};

export default ManageGeofence;